/* eslint-disable arrow-parens */
import { Grid } from "@mui/material";
import { EnrollmentTabLabelProps, StatusIcon } from "../../../../types/components/enrollmentProps.types";

import PanToolOutlinedIcon from "@mui/icons-material/PanToolOutlined";
import DoneAllOutlinedIcon from "@mui/icons-material/DoneAllOutlined";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import LockIcon from "@mui/icons-material/Lock";

import "./enrollmentTabLabel.css";

const getStatusIcon: StatusIcon = {
	ACTIVE: <DoneAllOutlinedIcon className="status-icon" />,
	SUBMITTED: <DoneAllOutlinedIcon className="status-icon" />,
	WAIVED: <PanToolOutlinedIcon className="status-icon" />,
	OPENED: <ArrowForwardIosIcon className="status-icon open-icon" />,
	CLOSED: <LockIcon className="status-icon" />
};

const EnrollmentTabLabel = ({
	planName,
	status,
	isOpenEnrollment,
	isActiveEnrollment
}: EnrollmentTabLabelProps): JSX.Element => {
	// console.log("EnrollmentTabLabel props:", { planName, status, isOpenEnrollment, isActiveEnrollment });
	return (
		<div className="enrollment-tab-level">
			<Grid container spacing={2} direction="row" justifyContent="space-between" alignItems="center">
				<Grid item style={{ display: "flex", flex: 1, alignItems: "center", justifyContent: "center" }}>
					<div className="plan-name">{planName}</div>
				</Grid>
				{isActiveEnrollment ? (
					<Grid item>
						<div>{getStatusIcon["ACTIVE"]}</div>
					</Grid>
				) : null}
				<Grid item>
					{isOpenEnrollment ? (
						<div className="open-icon-container">{getStatusIcon["OPENED"]}</div>
					) : status ? (
						<div>{getStatusIcon[status as keyof StatusIcon]}</div>
					) : null}
				</Grid>
			</Grid>
		</div>
	);
};

export default EnrollmentTabLabel;
